/**
 * Extracts the filename from a URL string
 * @param {string} url - The URL to extract filename from
 * @returns {string} The extracted filename, or the original URL if extraction fails
 */
export default function extractFilenameFromUrl(url) {
  try {
    const urlObj = new URL(url)
    const pathname = urlObj.pathname
    const filename = pathname.split('/').pop()
    return decodeURIComponent(filename) || url
  } catch {
    // If URL parsing fails, try basic string extraction
    const parts = url.split('/')
    const lastPart = parts[parts.length - 1]
    // Remove query string if present
    const filename = lastPart.split('?')[0]
    return decodeURIComponent(filename) || url
  }
}
